import React, {useMemo} from 'react'
import PropTypes from 'prop-types'
import {Flex, Skeleton, Text} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'
import {TollIcon} from '~/react/icons'

export const PointsPanel = ({paymentAmount, isLoading}) => {
  const {t} = useTranslation('pointsOnPayments')

  const points = useMemo(() => {
    if (!paymentAmount) return 0

    return Math.ceil(paymentAmount / 100)
  }, [paymentAmount])

  const showPoints = !isLoading && points

  const withPointsStyles = useMemo(() => {
    if (!showPoints) {
      return {}
    }

    return {
      background:
        'linear-gradient(#fff, #fff) padding-box, linear-gradient(to bottom, #FF4D00, #E044A5, #FDF167) border-box',
      backgroundClip: 'padding-box, border-box',
    }
  }, [showPoints])

  return (
    <Flex
      boxShadow="lg"
      rounded="md"
      overflow="visible"
      background="white"
      justify="space-between"
      gap="sm"
      p="md"
      border="2px solid transparent"
      borderRadius="lg"
      {...withPointsStyles}
    >
      <Flex gap="xxs" align="center">
        <TollIcon fontSize="24px" />
        <Text as="h4" textStyle="headline4">
          {t('pointsOnPayments:paymentWizard.formPanel.mCoinPanel.title')}
        </Text>
      </Flex>
      <Skeleton isLoaded={showPoints}>
        <Text minW="100px" as="h4" textStyle="headline4" textAlign="right">
          <Text as="span" color="mld.success.700" pr="xxs">
            +
          </Text>
          {points.toLocaleString()}
        </Text>
      </Skeleton>
    </Flex>
  )
}

PointsPanel.defaultProps = {
  paymentAmount: null,
}

PointsPanel.propTypes = {
  paymentAmount: PropTypes.number,
  isLoading: PropTypes.bool.isRequired,
}
